import React, { useEffect, useState } from 'react';
import FilterButton from './FilterButton';
import LockToggle from './LockToggle';
import PriceToggle from './PriceToggle';

const Filters = ({ darkMode, filters, toggleFilter, resetFilters, racks }) => {
  // Получаем уникальные значения для фильтров из данных о багажниках
  const [filterOptions, setFilterOptions] = useState({
    rackBrands: [],
    rackColors: [],
    rackBarTypes: [],
    rackCountries: [],
    rackCapacities: [],
  });

  // Предопределенные диапазоны цен
  const rackPriceRanges = [
    { label: "до 3000", value: { max: 3000 } },
    { label: "до 5000", value: { max: 5000 } },
    { label: "до 8000", value: { max: 8000 } },
    { label: "до 12000", value: { max: 12000 } },
    { label: "до 15000", value: { max: 15000 } },
    { label: "от 15000", value: { min: 15000 } }
  ];

  // Извлекаем уникальные значения из данных о багажниках
  useEffect(() => {
    // Если racks не передан или пуст, используем данные из всех багажников
    if (!racks || racks.length === 0) {
      // Импортируем данные о багажниках напрямую
      import('../../data/racks.json').then(racksData => {
        const allRacks = racksData.default;
        setFilterOptions({
          rackBrands: [...new Set(allRacks.map(rack => rack.brand))],
          rackColors: [...new Set(allRacks.map(rack => rack.color))],
          rackBarTypes: [...new Set(allRacks.map(rack => rack.bar_type))],
          rackCountries: [...new Set(allRacks.map(rack => rack.country))],
          rackCapacities: [...new Set(allRacks.map(rack => rack.capacity))],
        });
      });
    } else {
      setFilterOptions({
        rackBrands: [...new Set(racks.map(rack => rack.brand))],
        rackColors: [...new Set(racks.map(rack => rack.color))],
        rackBarTypes: [...new Set(racks.map(rack => rack.bar_type))],
        rackCountries: [...new Set(racks.map(rack => rack.country))],
        rackCapacities: [...new Set(racks.map(rack => rack.capacity))],
      });
    }
  }, [racks]);

  // Обработчик для переключения цены
  const handlePriceToggle = (value) => {
    // Если выбран тот же диапазон, сбрасываем его
    if (filters.priceRange &&
      ((filters.priceRange.min === value.min && filters.priceRange.max === value.max) ||
        (filters.priceRange.min === value.min && !filters.priceRange.max && !value.max) ||
        (!filters.priceRange.min && !value.min && filters.priceRange.max === value.max))) {
      toggleFilter('priceRange', null);
    } else {
      // Иначе устанавливаем новый диапазон
      toggleFilter('priceRange', value);
    }
  };

  return (
    <div className={`rounded-lg shadow p-4 mb-6 ${darkMode ? 'bg-gray-800 text-white' : 'bg-white'
      }`}>
      <div className="flex justify-between items-center mb-0">
        <h3 className="font-semibold">Фильтры:</h3>
        <button
          onClick={resetFilters}
          className={`text-sm px-4 py-2 rounded-lg ${darkMode ? 'bg-red-700 text-white' : 'bg-red-500 text-white'
            }`}
        >
          Сбросить фильтры
        </button>
      </div>

      <div className="mb-0">
        <h4 className="font-medium mb-0">Бренд:</h4>
        <div className="flex flex-wrap">
          {filterOptions.rackBrands.map(brand => (
            <FilterButton
              key={brand}
              label={brand}
              active={filters.brands.includes(brand)}
              onClick={() => toggleFilter('brand', brand)}
              darkMode={darkMode}
            />
          ))}
        </div>
      </div>

      <div className="mb-0">
        <h4 className="font-medium mb-0">Цвет:</h4>
        <div className="flex flex-wrap">
          {filterOptions.rackColors.map(color => (
            <FilterButton
              key={color}
              label={color}
              color={color}
              active={filters.colors.includes(color)}
              onClick={() => toggleFilter('color', color)}
              darkMode={darkMode}
            />
          ))}
        </div>
      </div>

      <div className="mb-0">
        <h4 className="font-medium mb-0">Тип дуги:</h4>
        <div className="flex flex-wrap">
          {filterOptions.rackBarTypes.map(type => (
            <FilterButton
              key={type}
              label={type}
              active={filters.barTypes.includes(type)}
              onClick={() => toggleFilter('barType', type)}
              darkMode={darkMode}
            />
          ))}
        </div>
      </div>

      <div className="mb-0">
        <h4 className="font-medium mb-0">Страна:</h4>
        <div className="flex flex-wrap">
          {filterOptions.rackCountries.map(country => (
            <FilterButton
              key={country}
              label={country}
              active={filters.countries.includes(country)}
              onClick={() => toggleFilter('country', country)}
              darkMode={darkMode}
            />
          ))}
        </div>
      </div>

      <div className="mb-0">
        <h4 className="font-medium mb-0">Грузоподъемность:</h4>
        <div className="flex flex-wrap">
          {filterOptions.rackCapacities.map(capacity => (
            <FilterButton
              key={capacity}
              label={capacity}
              active={filters.capacities.includes(capacity)}
              onClick={() => toggleFilter('capacity', capacity)}
              darkMode={darkMode}
            />
          ))}
        </div>
      </div>

      <div className="mb-0">
        <h4 className="font-medium mb-0">Замок:</h4>
        <LockToggle
          value={filters.lock}
          onChange={(value) => toggleFilter('lock', value)}
          darkMode={darkMode}
        />
      </div>

      <div className="mb-0">
        <h4 className="font-medium mb-0">Подборки по цене:</h4>
        <PriceToggle
          ranges={rackPriceRanges}
          selectedRange={filters.priceRange}
          onChange={handlePriceToggle}
          darkMode={darkMode}
        />
      </div>
    </div>
  );
};

export default Filters;